//
//
//
//
//
//
//
//
//
//
//
//

import manualButton from '../manual-button';
export default {
  name: "source-p",
  components: {
    manualButton,
  },
  data() {
    return {
      show: true,
      stageList: [
        {name: '全部', code: '', selected: true},
        {name: '新建/立项', code: 'newSource'},
        {name: '报名/预审', code: 'enroll'},
        {name: '报价/投标', code: 'offer'},
        {name: '报价已完成', code: 'offerFinish'}
      ],
      statusList:[
        {name: '全部', code:'', selected: true},
        {name: '草稿', code:'draft'},
        {name: '审批退回', code:'approvalReturn'},
        {name: '审批中', code:'inApproval'},
        {name: '已生效', code:'effective'},
        {name: '已作废', code:'Invalid'}
      ],
      sourceChildTypeList: [
        {name: '全部', code: '', selected: true},
        {name: '物品类', code: 'code1'},
        {name: '项目类', code: 'code2'},
        {name: '服务类', code: 'code3'},
      ],
      sourceWayList: [
        {name: '全部', code: '', selected: true},
        {name: '公开参与', code: 'PUBLIC'},
        {name: '邀请参与', code: 'INVITATION'},
      ],
      checkedDtoList:[]
    }
  },
  methods: {
    closeReset(){},
    reload(){
      this.checkedDtoList=[];
      this.show=false;
      this.$nextTick(()=>{
        this.show=true;
      })
    },
    checkerChange(value,name,chinese,option="IN"){
      this.checkedDtoList=this.checkedDtoList.filter(val=>val.name!=name)
      this.checkedDtoList.push({name,code:value,ch:chinese,option:option});
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/manual-search/source-p.vue